export default __webpack_public_path__ + "static/media/gas.9f642351.svg";